import React, { ChangeEvent, KeyboardEvent, useState, useEffect } from 'react'
import { http } from '../../Service/http'
import { report } from '../../store/report'
import Input from '../../Components/Select/Input'
import { BsSearch } from 'react-icons/bs'
import { direction } from '../../store/direction'
import { useTranslation } from 'react-i18next'
import { getReportTypeTeacher } from '../../Service/report'
import { reportTeacher } from '../../store/reportTeacher'
import Selector from '../../Components/Select/Select'
import { SelectTypeTeacher } from '../../store/modelsTeacher'

function ApplicaionsDone() {
	const [searchText, setText] = useState<string>('')
	const { t } = useTranslation()
	const [reportType, setReportType] = useState<SelectTypeTeacher>({
		label: 'Все',
		value: 0
	})

	const getReport = async () => {
		const res = await getReportTypeTeacher()
		report.newReportTypes(res)
	}
	useEffect(() => {
		getReport()
	}, [])


	const getTeachersByName = async (id:any) => {
		const res = await http.post('/report/reportTeacherApplicationDone', {
			s_fio_document: searchText,
			id_okno_document:id,
			status: true
		})
		console.log('res.data.reportApplicationDone',res.data.reportApplicationDone)
    reportTeacher.newReportTeacher(res.data.reportApplicationDone)
	}



	useEffect(() => {
		if(reportType?.value!==0 && direction.leftOrRight == 'right' ){
		getTeachersByName(reportType.value)
		reportTeacher.newTypeTeacher(reportType.value)
	}
		else if(direction.leftOrRight == 'right' ){
			getTeachersByName(0)
		}
	}, [direction.leftOrRight,reportType])

	return (
		<div style={{ margin: '0 auto', width: '100%', display: 'flex', alignItems: 'flex-end', justifyContent: 'center' }}>
			<Selector
					options={[
						{
							value: 0,
							label: 'Все'
						},
						...report.reportTypes
					]}
					value={reportType}
					placeholder={'Выберите!'}
					onChange={setReportType}
					isSearchable={true}
					isDisabled={false}
					isClearable={false}
					title={''}
					name={'search'}
					withBorder={true}
				/>
			<Input
				style={{ width: '80%', zIndex: '1' }}
				placeholder={t('st:placeHolder.byFio')}
				value={searchText}
				oninput={setText}
				keyDown={(e: KeyboardEvent<HTMLInputElement>) => {
					if (e.key == 'Enter') {
						getTeachersByName(reportType?.value!==null ? reportType?.value :0)
					}
				}}
			/>
			<BsSearch className='search_icon' onClick={()=>getTeachersByName(reportType?.value!==null ? reportType?.value :0)} />
		</div>
	)
}

export default ApplicaionsDone
